<template>
    <div>
        <page-title>盗版管理</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/illegal/edit">
                            <el-button type="text">手动添加</el-button>
                        </router-link>
                    </div>
                    <div flex="dir:right box:last cross:center">
                        <div>
                            <el-form :inline="true" @submit.native.prevent>
                                <el-form-item style="margin-bottom: 0; max-width: 150px">
                                    <el-input v-model="keyword"
                                              @keyup.enter.native="search()"
                                              size="mini"
                                              placeholder="域名/备案主体"
                                              suffix-icon="el-icon-search"/>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="domain" label="域名">
                    <template slot-scope="scope">
                        <div>{{scope.row.domain}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="subject" label="备案主体">
                    <template slot-scope="scope">
                        <div>{{scope.row.subject}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注">
                    <template slot-scope="scope">
                        <div>{{scope.row.remark}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <router-link :to="'/dashboard/admin/illegal/edit?id=' + scope.row.id">编辑</router-link>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="deleteIllegal(scope.row)">删除</el-button>
                        </template>
                        <template v-else>
                            <span style="color: #909399">已删除</span>
                            <span class="text-split">|</span>
                            <el-button type="text" @click="recoveryIllegal(scope.row)">恢复</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    data() {
        return {
            loading: false,
            list: null,
            pagination: null,
            keyword: ''
        }
    },
    created() {
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/illegal/index',
                    params: {
                        page: page,
                        keyword: this.keyword
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteIllegal(illegal) {
            new Promise(resolve => {
                this.$confirm('此操作将删除该域名, 是否继续?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(illegal)
                }).catch(() => {
                })
            }).then(illegal => {
                this.loading = true
                axios({
                    url: 'admin/illegal/delete',
                    params: {
                        id: illegal.id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        illegal.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryIllegal(illegal) {
            this.loading = true
            axios({
                url: 'admin/illegal/recovery',
                params: {
                    id: illegal.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    illegal.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
